export const MAX_REVIEW_HIGHLIGHTS = 3
